import { render, staticRenderFns } from "./SignupView.vue?vue&type=template&id=4e0a6ba0&"
import script from "./SignupView.vue?vue&type=script&lang=ts&"
export * from "./SignupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports